// removed by extract-text-webpack-plugin
module.exports = {"widget_container":"ixK9zGfWHHmOB8mIP1ooe","widget_container_title":"_3EffW03O07VJX8ifoJc5nq","left":"_3gRhfp8uYda43P7jooo7kZ","right":"_3SUbQf6BQW79H5_odBQqWP","widget_container_content":"_1Lelh8KFcjO9PnQY8zzcq3"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/Style/WidgetContainer/WidgetContainer.scss
// module id = 2123
// module chunks = 1